"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function (fn, threshhold) {
    if (threshhold === void 0) { threshhold = 300; }
    var last;
    var timer;
    return function () {
        var _this = this;
        var args = arguments;
        var now = +new Date();
        if (last && now < last + threshhold) {
            clearTimeout(timer);
            timer = setTimeout(function () {
                last = now;
                fn.apply(_this, args);
            }, threshhold);
        }
        else {
            last = now;
            fn.apply(this, args);
        }
    };
});
//# sourceMappingURL=throttle.utils.js.map